import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ErrorOutline as ErrorIcon } from '@mui/icons-material';

function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        p: 3,
        backgroundColor: '#f5f5f5',
      }}
    >
      <ErrorIcon sx={{ fontSize: 120, color: 'warning.main', mb: 3 }} />

      <Typography
        variant="h1"
        sx={{
          fontSize: '6rem',
          fontWeight: 'bold',
          color: 'text.primary',
          mb: 2,
        }}
      >
        404
      </Typography>

      <Typography variant="h4" gutterBottom sx={{ mb: 1 }}>
        {t('notFound.title')}
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 500 }}>
        {t('notFound.description')}
      </Typography>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          onClick={handleGoBack}
          id="goBack"
          name="goBack"
          data-testid="notFound-button-goBack"
        >
          {t('notFound.goBack')}
        </Button>
        <Button
          variant="contained"
          onClick={handleGoHome}
          id="goHome"
          name="goHome"
          data-testid="notFound-button-goHome"
        >
          {t('notFound.goHome')}
        </Button>
      </Box>
    </Box>
  );
}

export default NotFound;
